import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { BpIntlTypes } from './types';

export type UseBpIntlFormatFn<T extends string, CUSTOM_DATA_TYPE extends string = string> = (
  key: T,
  value?: Record<string, BpIntlTypes.PrimitiveType<CUSTOM_DATA_TYPE>>
) => string;

export function useBpIntlFormat<INTL extends Record<string, string>, CUSTOM_DATA_TYPE extends string = string>(
  messages: INTL
): UseBpIntlFormatFn<keyof INTL & string, CUSTOM_DATA_TYPE> {
  const { formatMessage } = useIntl();
  return useCallback(
    (key: keyof INTL & string, value?: Record<string, BpIntlTypes.PrimitiveType<CUSTOM_DATA_TYPE>>) => {
      const messageDetails = messages[key as keyof typeof messages];
      if (!messageDetails) {
        return key;
      }
      const defaultMessage = messages[key as keyof typeof messages];
      return formatMessage({ id: key, defaultMessage }, value);
    },
    [formatMessage, messages]
  );
}
